"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProgressable = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isProgressable = (obj) => {
    return obj.progress && typeof obj.progress === 'function';
};
exports.isProgressable = isProgressable;
//# sourceMappingURL=Progressable.js.map